import { StyleSheet } from 'react-native';
import {
    LIGHT_GREY_COLOR,
    PRIMARY_COLOR, RED_COLOR,
} from 'coooltv-js-shared/src/styles/common';
import {
    BLUE_COLOR, GREY_COLOR, HOVERED_COLOR, WHITE_COLOR,
} from '../styles/common';

export const wrapperStyles = StyleSheet.create({
    main_wrapper: {
        marginTop: 50,
        paddingHorizontal: '6%',
        paddingVertical: '3%',
        paddingTop: 110,
        backgroundColor: WHITE_COLOR,
    },
    main_wrapper_phone: {
        paddingHorizontal: 15,
        marginTop: 90,
        paddingVertical: '3%',
        backgroundColor: WHITE_COLOR,
    },
    home_button_text: {
        color: BLUE_COLOR,
        fontSize: 18,
    },
    home_button_text_disabled: {
        color: GREY_COLOR,
        fontSize: 18,
    },
    buttons_wrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 25,
        marginTop: 50,
    },
    buttons_wrapper_phone: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginVertical: 40,
    },
    row_direction: {
        flexDirection: 'row',
    },
    col_direction: {
        flexDirection: 'column',
        height: 60,
        justifyContent: 'space-between',
    },
    icon_wrapper: {
        flexDirection: 'row',
        marginRight: 20,
    },
});

export const pageStyles = StyleSheet.create({
    wrapper: {
        borderTopWidth: 1,
        borderRightStyle: 'solid',
        borderColor: PRIMARY_COLOR,
        display: 'flex',
        marginTop: -2,
        paddingTop: 90,
        flexDirection: 'column',
        justifyContent: 'center',
    },
    wrapper_phone: {
        borderTopWidth: 1,
        borderRightStyle: 'solid',
        borderColor: PRIMARY_COLOR,
        display: 'flex',
        flexDirection: 'column',
        marginTop: -2,
        paddingTop: '10%',
        justifyContent: 'center',
        marginBottom: '-10%',
    },
    external_wrapper: {
        zIndex: 1,
        width: '100%',
    },
    phone_wrapper: {
        paddingHorizontal: 15,
    },
    inputs_wrapper: {
        width: 470,
        alignItems: 'center',
        alignSelf: 'center',
    },
    inputs_wrapper_phone: {
        width: '100%',
        alignSelf: 'center',
        alignItems: 'center',
    },
    primary_error: {
        fontSize: 16,
        textAlign: 'center',
        color: RED_COLOR,
        marginTop: 5,
        marginBottom: 10,
    },
    text_input_error: {
        fontSize: 16,
        textAlign: 'center',
        color: RED_COLOR,
        marginTop: -20,
        marginBottom: 20,
    },
    added: {
        marginTop: 40,
        marginHorizontal: 5,
    },
    available: {
        marginTop: 90,
        marginHorizontal: 5,
    },
    light_blue: {
        color: BLUE_COLOR,
        fontSize: 16,
    },
    centered: {
        alignSelf: 'center',
        marginHorizontal: 10,
    },
    channels_label: {
        color: GREY_COLOR,
        fontSize: 24,
        marginBottom: 40,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: '100%',
    },
    channels_label_phone: {
        fontSize: 18,
        alignItems: 'start',
        color: GREY_COLOR,
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    up_button: {
        marginBottom: 10,
    },
    empty_row_styles: {
        backgroundColor: LIGHT_GREY_COLOR,
        height: 40,
    },
    available_channels_label: {
        color: GREY_COLOR,
        marginBottom: 10,
        fontSize: 24,
    },
    available_channels_label_phone: {
        marginBottom: 20,
        color: GREY_COLOR,
        fontSize: 18,
    },
    channel_label_container: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 4,
        paddingHorizontal: 10,
    },
    channel_label_first_column: {
        flexBasis: '5%',
        color: GREY_COLOR,
        fontSize: 16,
    },
    channel_label_first_column_phone: {
        flexBasis: '10%',
        color: GREY_COLOR,
        fontSize: 16,
    },
    channel_label_second_column: {
        flexBasis: '30%',
        color: GREY_COLOR,
        fontSize: 16,
    },
    channel_label_third_column: {
        flexBasis: '20%',
        color: GREY_COLOR,
        fontSize: 16,
    },
    channel_label_fourth_column: {
        flexBasis: '10%',
        color: GREY_COLOR,
        fontSize: 16,
    },
    channel_label_fifth_column: {
        flexBasis: '35%',
        color: GREY_COLOR,
        fontSize: 16,
    },
    channel_items_container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        height: '100%',
    },
    small_rows: {
        height: 40,
    },
    large_rows: {
        height: 80,
    },
    grey_background: {
        backgroundColor: LIGHT_GREY_COLOR,
    },
    horizontal_pad: {
        paddingHorizontal: 10,
    },
    channel_items: {
        color: GREY_COLOR,
        fontSize: 16,
        alignSelf: 'center',
    },
    channel_items_first_column: {
        flexBasis: '5%',
    },
    channel_items_second_column: {
        flexBasis: '30%',
    },
    channel_items_third_column: {
        flexBasis: '20%',
    },
    channel_items_fourth_column: {
        flexBasis: '10%',
    },
    channel_items_fifth_column: {
        flexBasis: '35%',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    action_buttons: {
        alignSelf: 'center',
    },
    action_buttons_margin: {
        marginLeft: 5,
    },
    channel_items_first_column_phone: {
        flexBasis: '10%',
    },
    channel_items_second_column_phone: {
        flexBasis: '40%',
    },
    channel_items_fifth_column_phone: {
        flexBasis: '45%',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    channel_items_action_button_column_phone: {
        flexBasis: '40%',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
    },
    channel_items_action_button_column_phone_all: {
        flexBasis: '50%',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    channel_items_number_column_phone: {
        flexBasis: '10%',
    },
    channel_items_name_column_phone: {
        flexBasis: '40%',
    },
    channel_items_action_button_column: {
        flexBasis: '35%',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    channel_items_name_column: {
        flexBasis: '30%',
    },
    channel_items_number_column: {
        flexBasis: '5%',
    },
    hovered: {
        backgroundColor: HOVERED_COLOR,
    },
});

export const tableRowOdd = {
    flexDirection: 'row',
    height: 40,
    alignItems: 'center',
    paddingLeft: 10,
    paddingRight: 10,
    backgroundColor: WHITE_COLOR,
};

export const tableRowEven = {
    ...tableRowOdd,
    backgroundColor: LIGHT_GREY_COLOR,
};

export const tableRowEvenPhone = {
    ...tableRowEven,
    height: 80,
};

export const tableRowOddPhone = {
    ...tableRowOdd,
    height: 80,
};

export const actionButton = {
    alignSelf: 'center',
    height: 15,
    width: 15,
};

export const actionButtonPhone = {
    ...actionButton,
    margin: 'auto',
};

export const dragButtonContainer = {
    flexBasis: '5%',
    width: '100%',
    height: '100%',
    color: GREY_COLOR,
    fontSize: 16,
    alignSelf: 'center',
};

export const dragButtonContainerPhone = {
    ...dragButtonContainer,
    flexBasis: '10%',
    display: 'flex',
    justifyContent: 'center',
};
